import * as React from "react";
import styled, { css } from "styled-components";
import Badge from "./Badge";
const StyledBadge = styled(Badge)(
  ({ theme }) => css`
    border-radius: 3px;
    font-weight: normal;
    padding-left: ${theme.spacings.xs};
    padding-right: ${theme.spacings.xs};
    text-align: center;

    .mantine-Badge-label {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${theme.spacings.xxs};
    }

    /* When a label's content is wrapped in a <span> (e.g. to carry a title tooltip), that span
       becomes a flex item of the label, so it needs to be its own single-line ellipsis context —
       otherwise long text overflows instead of truncating when the label is width-constrained. */
    .mantine-Badge-label > span {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `
);
const Label = ({
  "aria-label": ariaLabel = void 0,
  bsSize = void 0,
  bsStyle = void 0,
  className = void 0,
  children = void 0,
  "data-testid": dataTestid = void 0,
  onClick = void 0,
  onMouseEnter = void 0,
  onMouseLeave = void 0,
  role = void 0,
  style = void 0,
  title = void 0,
  uppercase = false
}) => /* @__PURE__ */ React.createElement(
  StyledBadge,
  {
    "aria-label": ariaLabel,
    bsSize,
    bsStyle,
    className,
    "data-testid": dataTestid,
    onClick,
    onMouseEnter,
    onMouseLeave,
    role,
    style,
    title,
    uppercase
  },
  children
);
export default Label;
